import React from 'react';
import bottomImage2 from '../assets/bottomThree/2.svg';

const CommunitySection = () => {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <img 
              src={bottomImage2}
              alt="Kids playing tennis together"
              className="w-full h-auto rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.1)]"
            />
          </div>
          
          <div className="py-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8">Join Our Tennis Community</h2>
            <p className="text-lg sm:text-xl md:text-2xl font-medium text-gray-600 leading-relaxed max-w-2xl">
              Be part of a welcoming group of players, parents, and supporters. Together, we grow 
              stronger – on and off the court. The community is built on passion, friendship, 
              and the love for the game.
            </p>
            
            {/* <div className="community-features">
              <div className="community-feature">
                <span className="feature-check">✓</span>
                <span>Weekly group training sessions</span>
              </div>
              <div className="community-feature">
                <span className="feature-check">✓</span>
                <span>Monthly community tournaments</span>
              </div>
              <div className="community-feature">
                <span className="feature-check">✓</span>
                <span>Family-friendly social events</span>
              </div>
              <div className="community-feature">
                <span className="feature-check">✓</span>
                <span>Junior development programs</span>
              </div>
            </div> */}
            
            {/* <a href="#join" className="btn btn-primary">Join Our Community</a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
